import { useEffect, useState } from 'react';
import { isAndroid, isIOS } from 'react-device-detect';

import { ModalsProvider } from '@speeki/global-ui-components';
import { SessionStorageManager } from '@speeki/storage-manager';

import { checkIfTeams } from '@utils/helpers';

import { useReactiveVar } from '@apollo/client';
import { authVar } from '@boot/reactiveVariables';
import {
    DEFAULT_URL_PREFIX,
    isLocalhost,
    REACT_APP_APP_DOMAIN,
} from '@shared/constants';

export const useCustomUrl = () => {
    const [customUrlLoading, setCustomUrlLoading] = useState(false);
    const [urlCompany] = window.location.host.split('.');

    const { isLoggedIn } = useReactiveVar(authVar);
    const hideDownloadAppModal = SessionStorageManager.getValue(
        'hideDownloadAppModal',
    );
    const showDownloadAppModal =
        (isAndroid || isIOS) &&
        !checkIfTeams() &&
        !isLoggedIn &&
        !hideDownloadAppModal;

    const slugRedirect = urlCompany !== DEFAULT_URL_PREFIX && !isLocalhost;

    useEffect(() => {
        if (slugRedirect) {
            const additionalPathName =
                window.location.pathname.includes('/download/incidentpdf') &&
                !window.location.pathname.includes('/download/incidentpdf/file')
                    ? window.location.pathname
                    : '';

            setCustomUrlLoading(true);
            window.location.href = `${window.location.protocol}//${REACT_APP_APP_DOMAIN}${additionalPathName}?companySlug=${urlCompany}`;
        }

        !slugRedirect &&
            showDownloadAppModal &&
            ModalsProvider.open('DownloadSpeekiAppModal');
        SessionStorageManager.setValue('hideDownloadAppModal', 'true');
    }, []);

    return {
        customUrlLoading,
    };
};
